import React from "react";
import { Modal } from "react-bootstrap";
import KpiTrendChart from "./KpiTrendChart";
import { setGraphModel } from "../../core/redux/overview/overview.action";
import { useSelector, useDispatch } from "react-redux";
const LineChartModal = () => {
  const dispatch = useDispatch()
  const { graphModel } = useSelector((state) => state.overview);
  const closeModal = () => {
    dispatch(setGraphModel(false))
  };
  return (
    <Modal show={graphModel} onHide={closeModal} centered size="xl">
      <Modal.Header closeButton>
        {/* <Modal.Title>line chart</Modal.Title> */}
      </Modal.Header>
      <Modal.Body >
        <KpiTrendChart />
      </Modal.Body>
    </Modal>
  );
};

export default LineChartModal;
